import { render, staticRenderFns } from "./EstColumnas.vue?vue&type=template&id=8c71f1ee"
import script from "./EstColumnas.vue?vue&type=script&lang=js"
export * from "./EstColumnas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports